declare global {
  interface Window {
    openPixDeposit: (value: number) => void;
  }
}

export default defineNuxtPlugin(() => {
  window.openPixDeposit = (value: number) => {
    if (!value || isNaN(value) || value <= 0) return;

    const { isAuthenticated } = storeToRefs(useAuthStore());

    if (!isAuthenticated.value) return;

    const { selectDepositMethod, setAutoSubmitDeposit } = useWalletStore();
    const { openDepositModal } = usePayments();

    selectDepositMethod('pix');
    setAutoSubmitDeposit(String(value));
    openDepositModal();
  };
});
